import { defineStore } from 'pinia';
export interface DynamicYieldChoice {
    name: string;
    decisionId: string;
    variations: DynamicYieldVariation[];
}

export interface DynamicYieldVariation {
    type: string;
    data: any;
    name: string;
    experienceName: string;
}

export interface DynamicYieldCookie {
    name: string;
    value: string;
    maxAge: number;
}

export interface DynamicYieldData {
    choices: DynamicYieldChoice[];
    cookies: DynamicYieldCookie[];
}

export interface DynamicYieldEvent {
    name: string;
    properties: Record<string, any>;
}

export interface DynamicYieldResponse {
    responseCode: number;
}

export const useDynamicYieldStore = defineStore('dynamicYieldStore', () => {
    const gtmStore = useGtmStore();
    const cookies = ref<DynamicYieldCookie[]>([]);
    const choices = ref<DynamicYieldChoice[]>([]);
    const nuxtApp = useNuxtApp();
    const config = nuxtApp.$config;

    async function fetchChoices(pagePath: string) {
        const response = await useNuxtApp().$siteFetch<DynamicYieldData>(`/dynamic-yield/choose-variations?pagePath=${pagePath}`);

        if (!!response) {
            choices.value = response.choices;
            cookies.value = response.cookies;
        }

        return response;
    }

    function pushVariantsToGtm() {
        choices.value.forEach(choice => {
            choice.variations.forEach(variation => {
                const variationEvent = {
                    event: 'DY Variation Impression',
                    campaignName: choice.name,
                    variationName: variation.name,
                    experienceName: variation.experienceName,
                };

                gtmStore.pushEvent(variationEvent);

                console.debug('Pushed variation event', variationEvent.campaignName, variationEvent.variationName);
            });
        });
    }

    function getDYIDCookieValue() {
        return cookies.value.find(cookie => cookie.name === '_dyid_server')?.value;
    }

    function getChoiceBySelector(selector: string) {
        return choices.value?.find((choice) => choice.name === selector);
    }

    function getVariationBySelectorAndType(selector: string, type: string) {
        const choice = getChoiceBySelector(selector);

        return choice?.variations?.find((variation) => variation?.type === type);
    }

    function getCustomJSONVariationBySelector(selector: string) {
        return getVariationBySelectorAndType(selector, 'CUSTOM_JSON');
    }

    async function trackEvent(name: string, properties: Record<string, any> = {}) {
        return trackEvents({
            name,
            properties,
        });
    }

    async function trackEvents(...data: DynamicYieldEvent[]) {
        // TODO; We need to swap to the Thorne Auth Library's fetch to support
        // forwarding appropriate session headers/cookies
        return await useNuxtApp().$siteFetch<DynamicYieldResponse>('/dynamic-yield/track-events', {
            method: 'POST',
            body: data,
        });
    }

    function $reset() {
        cookies.value = [];
        choices.value = [];
    }

    const dynamicYieldTruemedData = computed(() => {
        const TruemedData = getCustomJSONVariationBySelector(config?.public?.dyCampaignKeyTruemed ?? '' );
        return TruemedData?.data ?? "";
    });

    const dynamicYieldOgData = computed(() => {
        const orderGrooveData = getCustomJSONVariationBySelector(config?.public?.dyCampaignKeyOG ?? '' );
        return orderGrooveData?.data?.enabled ?? "";
  });


    return { cookies, choices, getDYIDCookieValue, getChoiceBySelector, getVariationBySelectorAndType, fetchChoices, pushVariantsToGtm, getCustomJSONVariationBySelector, trackEvent, trackEvents, $reset, dynamicYieldTruemedData, dynamicYieldOgData };
});